import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import SelectableRecordsTable from 'components/selectable_record_table/selectable_record_table';
import SelectableRow from 'components/selectable_record_table/selectable_row';
import CsvDownloadButton from  'components/csv_download_button';

export default class ImportReview extends React.Component {
  static propTypes = {
    enumColumnLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
    enumColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
    fieldColumnLabels: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    fieldColumns: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    headerRow: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    headerRowLabels: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    importJobId: PropTypes.number.isRequired,
    summary: PropTypes.shape({
      failed: PropTypes.number.isRequired,
      failedRecords: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
      imported: PropTypes.number.isRequired,
      importedRecords: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
      updated: PropTypes.number.isRequired,
      updatedRecords: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired
    }).isRequired
  }

  render() {
    const { importJobId, summary } = this.props;

    return (
      <React.Fragment>
        {summary.failed > 0 && (
          <React.Fragment>
            <div className="review-header">
              {this.renderCount('failed import', summary.failed, true)}
              <CsvDownloadButton entityName="failed records" href={`/import_jobs/${importJobId}.csv`} />
            </div>
            {this.renderTable(summary.failedRecords, true)}
          </React.Fragment>
        )}
        {summary.imported > 0 && (
          <React.Fragment>
            {this.renderCount('successful import', summary.imported)}
            {this.renderTable(summary.importedRecords)}
          </React.Fragment>
        )}
        {summary.updated > 0 && (
          <React.Fragment>
            {this.renderCount('updated record', summary.updated)}
            {this.renderTable(summary.updatedRecords)}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }

  renderCount(text, count, withErrors) {
    return (
      <h4 className="mb-4 mt-5 text-uppercase" name="reviewCount">
        <strong className={`text-${withErrors ? 'danger' : 'muted'}`}>{pluralize(text, count, true)}</strong>
      </h4>
    );
  }

  renderTable(records, withErrors = false) {
    const { enumColumnLabels, fieldColumnLabels } = this.props;

    const columnHeaders = [...fieldColumnLabels, ...enumColumnLabels];
    if (withErrors) {
      columnHeaders.push("Errors");
    }

    return (
      <div className="table-responsive mb-5">
        <SelectableRecordsTable
          className="field-mapping-table"
          columnHeaders={columnHeaders.map((label, i) => <th key={i}>{label}</th>)}
          hasSelectAll={false}
          hasSelectColumn={false}
          name="importReviewTable"
        >
          {records.map(withErrors ? this.renderFailedRow : this.renderImportedRow)}
        </SelectableRecordsTable>
      </div>
    );
  }

  renderImportedRow = (record) => {
    const { enumColumns, fieldColumns } = this.props;

    return (
      <SelectableRow hideCheckbox key={record.id}>
        {this.renderCells(fieldColumns, record)}
        {this.renderCells(enumColumns, record)}
      </SelectableRow>
    );
  }

  renderFailedRow = (record) => {
    const { enumColumns, fieldColumns } = this.props;

    return (
      <SelectableRow hideCheckbox key={record.id}>
        {this.renderCells(fieldColumns, record)}
        {this.renderCells(enumColumns, record)}
        {this.renderErrors(record)}
      </SelectableRow>
    );
  }

  renderCells(columns, record) {
    return columns.map(column => <td key={`${column}${record.id}`}>{record[column]}</td>);
  }

  renderErrors(record) {
    return (
      <td>
        {record.errors.map((e, i) => <div className="error-text" key={`errors${record.id}_${i}`}>{e}</div>)}
      </td>
    );
  }
}
